import { render, staticRenderFns } from "./download.vue?vue&type=template&id=3e31a31c&scoped=true&"
var script = {}
import style0 from "./download.vue?vue&type=style&index=0&id=3e31a31c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31a31c",
  null
  
)

export default component.exports